import { defineComponent as _defineComponent } from 'vue'
import { UserReportRow, PositionType } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { sumBy, every } from "lodash";
import { customMoment } from "@/main";
import { computed } from "vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionStatementsModal',
  props: {
    userStatement: null,
    value: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { userStatement: UserReportRow, value: boolean };





const { $t } = useTranslation();

const companyPositions = computed(() => {
  return props.userStatement.positionStatements
    ?.filter((s) => s.positionType === PositionType.Company)
    .sort((a, b) => {
      return customMoment(a.releaseDate).isAfter(customMoment(b.releaseDate))
        ? -1
        : 1;
    });
});

const placeOutPositions = computed(() => {
  return props.userStatement.positionStatements
    ?.filter((s) => s.positionType === PositionType.Outset)
    .sort((a, b) => {
      return customMoment(a.releaseDate).isAfter(customMoment(b.releaseDate))
        ? -1
        : 1;
    });
});

const uplinePositions = computed(() => {
  return props.userStatement.positionStatements
    ?.filter((s) => s.positionType === PositionType.Upline)
    .sort((a, b) => {
      return customMoment(a.releaseDate).isAfter(customMoment(b.releaseDate))
        ? -1
        : 1;
    });
});

const companyPositionSubtotal = computed(() => {
  if (!companyPositions.value) {
    return null;
  }
  const uplineIntakeAmount = sumBy(
    companyPositions.value,
    (p) => p.uplineIntakeAmount
  );
  const contributeAmount = sumBy(
    companyPositions.value,
    (p) => p.contributeAmount
  );
  const companyStake = contributeAmount / uplineIntakeAmount;
  return {
    uplineIntakeAmount,
    uplineIntakeNet: sumBy(companyPositions.value, (p) => p.uplineIntakeNet),
    contributeAmount,
    uplinePlFight: sumBy(companyPositions.value, (p) => p.uplinePlFight),
    uplineStake: companyStake,
    uplinePosition: sumBy(companyPositions.value, (p) => p.uplinePosition),
  };
});

const placeoutPositionSubtotal = computed(() => {
  if (!placeOutPositions.value) {
    return null;
  }
  const uplineIntakeAmount = sumBy(
    placeOutPositions.value,
    (p) => p.uplineIntakeAmount
  );
  const contributeAmount = sumBy(
    placeOutPositions.value,
    (p) => p.contributeAmount
  );
  const companyStake = contributeAmount / uplineIntakeAmount;
  return {
    uplineIntakeAmount,
    uplineIntakeNet: sumBy(placeOutPositions.value, (p) => p.uplineIntakeNet),
    contributeAmount,
    uplinePlFight: sumBy(placeOutPositions.value, (p) => p.uplinePlFight),
    uplineStake: companyStake,
    uplinePosition: sumBy(placeOutPositions.value, (p) => p.uplinePosition),
  };
});

const uplinePositionSubtotal = computed(() => {
  if (!uplinePositions.value) {
    return null;
  }
  const uplineIntakeAmount = sumBy(
    uplinePositions.value,
    (p) => p.uplineIntakeAmount
  );
  const contributeAmount = sumBy(
    uplinePositions.value,
    (p) => p.contributeAmount
  );
  const companyStake = contributeAmount / uplineIntakeAmount;
  return {
    uplineIntakeAmount,
    uplineIntakeNet: sumBy(uplinePositions.value, (p) => p.uplineIntakeNet),
    contributeAmount,
    uplinePlFight: sumBy(uplinePositions.value, (p) => p.uplinePlFight),
    uplineStake: companyStake,
    uplinePosition: sumBy(uplinePositions.value, (p) => p.uplinePosition),
  };
});

const positionTotal = computed(() => {
  const subtotals = [
    companyPositionSubtotal.value,
    uplinePositionSubtotal.value,
    // this.placeoutPositionSubtotal
  ] as {
    uplineIntakeAmount: number;
    uplineIntakeNet: number;
    contributeAmount: number;
    uplinePlFight: number;
    uplineStake: number;
    uplinePosition: number;
  }[];

  if (!every(subtotals)) {
    return null;
  }
  const filteredSubTotals = subtotals.filter(
    (subtotal) => subtotal.uplinePosition
  );
  return {
    uplineIntakeAmount: sumBy(
      filteredSubTotals,
      (subtotal) => subtotal.uplineIntakeAmount
    ),
    uplineIntakeNet: sumBy(subtotals, (subtotal) => subtotal.uplineIntakeNet),
    contributeAmount: sumBy(subtotals, (subtotal) => subtotal.contributeAmount),
    uplinePlFight: sumBy(subtotals, (subtotal) => subtotal.uplinePlFight),
    uplineStake: sumBy(subtotals, (subtotal) => subtotal.uplineStake),
    uplinePosition:
      sumBy(subtotals, (subtotal) => subtotal.uplinePosition) +
      (props.userStatement.variableExpenses || 0),
  };
});

function formatDate(date: string) {
  return customMoment(date).format("DD-MM-YYYY");
}

function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,props, emit, $t, companyPositions, placeOutPositions, uplinePositions, companyPositionSubtotal, placeoutPositionSubtotal, uplinePositionSubtotal, positionTotal, formatDate, toggleModal, formatDollar }
}

})